import React from 'react';
import './IntegrationDiscovery.css';
// import apiClient from '../../api/client';
import config from '../../config/environment';

const IntegrationDiscovery = () => {
  const integrations = [
    { name: 'Five', status: 'Active' },
    { name: 'Adobe Enterprise', status: 'Active' },
    { name: 'Aha!', status: 'Active' },
    { name: 'Aircall', status: 'Active' },
    { name: 'Airtable', status: 'Active' },
    { name: 'Alfresco', status: 'Active' },
    { name: 'Asana', status: 'Active' },
    { name: 'Atlassian', status: 'Active' },
    { name: 'Auth0', status: 'Active' },
    { name: 'AWS', status: 'Active' },
    { name: 'Azure Automation', status: 'Active' },
    { name: 'BambooHR', status: 'Active' },
    { name: 'BlueJeans', status: 'Active' },
    { name: 'Bonusly', status: 'Active' },
    { name: 'Box', status: 'Active' },
    { name: 'Bugnag', status: 'Active' },
    { name: 'Calendly', status: 'Active' },
    { name: 'Certify', status: 'Active' },
  ];

  const handleCardClick = async (integration) => {
    // Build URL with provider name in the path
    const providerName = encodeURIComponent(integration.name);
    const url = `/integration-popup-window/${providerName}?status=${encodeURIComponent(integration.status)}`;
    
    console.log(url);

    // try {
      const baseUrl = config.apiBaseUrl;
      const urlRedirect = `${baseUrl}/api/integrations/Dropbox/connect?authType=oauth2`;
      console.log(urlRedirect);
      // const result = await apiClient.connectIntegration("Dropbox");
      window.location.href = `${baseUrl}/api/integrations/Dropbox/connect?authType=oauth2`;
      
    //   console.log('Result:', result);
      
    //   if (result.status === 302 && result.redirectUrl) {
    //     // Navigate to the OAuth authorization page in the same popup window
    //     // Using replace() to avoid CORS preflight issues
    //     console.log('Redirecting to:', result.redirectUrl);
    //     window.location.replace(result.redirectUrl);
    //     return;
    //   }
      
    //   // setConnectionStatus('Connected successfully!');
    //   console.log('Connection successful:', result);
    // } catch (error) {
    //   // setConnectionStatus('Connection failed. Please try again.');
    //   console.error('Connection error:', error);
    // } finally {
    //   // setIsConnecting(false);
    // }

    // Open popup window first
    // window.open(
    //   url,
    //   `integration-${integration.name.toLowerCase().replace(/\s+/g, '-')}`,
    //   'width=700,height=600,noopener,noreferrer,resizable=yes,scrollbars=yes,status=no'
    // );
  };

  return (
    <div className="integration-discovery">
      <div className="integrations-grid">
        {integrations.map((integration, idx) => (
          <div key={idx} className="integration-card" onClick={() => handleCardClick(integration)} style={{ cursor: 'pointer' }}>
            <div className="integration-icon">📦</div>
            <div className="integration-name">{integration.name}</div>
            <div className="integration-type">BetterCloud UI Built</div>
            <div className="integration-status">{integration.status}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationDiscovery; 